<div class="pad15 withpopupCard card">
    <div class="row">
        <div class="col-lg-2 col-md-3 col-sm-3">
            <label class="form-label" translate>lblChannel</label>
            <div class="d-flex">
                <select class="form-control" (change)="onChannelChange($event.currentTarget.value)">
                    <option *ngFor="let data of lstChannelType" [ngValue]="data.id" translate>
                        {{data.label}}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-3">
            <label class="form-label" translate>lblWoNo</label>
            <div class="d-flex input-group">
                <input type="text" class="form-control" tabindex="1" [(ngModel)]="this.commRequestModel.WorkOrderNo" (change)="OnWorkOrderSearch()" autocomplete="off">
                <div class="input-group-append">
                    <button type="button" class="add-button btn btn-primary radius-lb-flat" (click)="OnWorkOrderSearch()"><em class="fa fa-search"></em></button>
                </div>
            </div>
        </div>
        <div class="font16 fontbold ml-auto mr-3">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{totalCount}}&nbsp;
            <span class="font16 fontnormal" translate>lblResults</span>
        </div>
    </div>
  </div>
<div class="scrollbar dwo">
    <div class="card">
        <div class="table-responsive max-h240" infinite-scroll
        [infiniteScrollDistance]="scrollDistance"
        [infiniteScrollThrottle]="throttle"
        [scrollWindow]="false"
        (scrolled)="onScrollDown($event)">
            <table class="tablest1 fixed-header">
                <thead>
                    <tr>
                        <th style="width: 5%" scope="col">#</th>
                        <th style="width: 5%" scope="col" sortable="WorkOrderNo" (sort)="onSort($event)" translate>lblWoNo</th>
                        <th style="width: 15%" scope="col" sortable="Sender" (sort)="onSort($event)" translate>lblSender</th>
                        <th style="width: 15%" scope="col" sortable="Receiver" (sort)="onSort($event)" translate>lblReceiver</th>
                        <th style="width: 10%" scope="col" sortable="Channel" (sort)="onSort($event)" translate>lblChannel</th>
                        <th style="width: 20%" scope="col" sortable="MsgSubject" (sort)="onSort($event)" translate>lblSubject</th>
                        <th style="width: 15%" scope="col" sortable="OnDate" (sort)="onSort($event)" translate>lblDate</th>
                        <th style="width: 5%" class="text-center" scope="col" translate>lblAction</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="lstCommunication?.length > 0; else load_else">
                        <tr *ngFor="let comm of lstCommunication; let i=index">
                            <td>{{i+1}}</td>
                            <td>
                                <ngb-highlight [result]="comm.workOrderNo"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="comm.sentBy"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="comm.receiver"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="comm.channel"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="comm.msgSubject"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="getLocalDate(comm.onDate) | date:'short'"></ngb-highlight>
                            </td>
                            <td class="nowrap text-center">
                                <a class="btn btn-ico" ngbTooltip="{{'lblView' | translate}}" (click)="ViewDetails(viewDetailContent, comm)">
                                    <em class="far fa-eye fa-lg"></em>
                                </a>
                            </td>
                        </tr>
                    </ng-container>
                    <ng-template #load_else>
                        <tr>
                            <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="p-3 bg-light pp-footer-top-brdr">
    <div class="row">
        <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
            <button type="button" class="add-button btn btn-secondary btn-lg" (click)="OnClose()"
                translate>lblCancel</button>
        </div>
    </div>
</div>

<!-- Popup for View Communication detail -->
<ng-template #viewDetailContent let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lbl{{communicationDetail.channel}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.close('Cross click')"><span aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive">
        <div class="card scrollbar">
            <div class="card-content">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 af-form-group">
                            <div class="row">
                                <div class="col">
                                    <strong translate class="font-14">lblDate</strong>
                                    <div>{{getLocalDate(communicationDetail.onDate) | date:'short'}}</div>
                                </div>
                                <div class="col">
                                    <strong translate class="font-14">lblWoNo</strong>
                                    <div>{{communicationDetail.workOrderNo}}</div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col">
                                    <strong translate class="font-14">lblSender</strong>
                                    <div>{{communicationDetail.sentBy}}</div>
                                </div>
                                <div class="col">
                                    <strong translate class="font-14">lblReceiver</strong>
                                    <div>{{communicationDetail.receiver}}</div>
                                </div>
                            </div>
                            <div class="row mt-3" *ngIf="communicationDetail.channel != 'SMS'">
                                <div class="col">
                                    <strong translate class="font-14">lblSubject</strong>
                                    <div>{{communicationDetail.msgSubject}}</div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col">
                                    <strong translate class="font-14">lblBody</strong>
                                    <div [innerHtml]="communicationDetail.msgBody" class="comm-body-scroll form-control"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md" (click)="modal.close('Cancel click')" translate>lblCancel</button>
    </div>
</ng-template>
